import { useState } from "react";
import { motion } from "framer-motion";
import api from "../utils/api";
import "./Login.css";

export default function Login({ isOpen, onClose }) {
  const [form, setForm] = useState({ email: "", password: "" });

  if (!isOpen) return null; // ❌ Modal hidden

  const handleChange = (e) =>
    setForm({ ...form, [e.target.name]: e.target.value });

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const res = await api.post("/users/login", form);

      localStorage.setItem("token", res.data.token);
      localStorage.setItem("role", res.data.user.role);

      alert("Login successful ✅");
      onClose(); // 🔥 Modal close after login
      window.location.reload(); // optional refresh
    } catch (err) {
      alert(err.response?.data?.msg || "Error occurred");
    }
  };

  return (
    <div className="modal-overlay">
      <motion.div
        initial={{ scale: 0.8, opacity: 0 }}
        animate={{ scale: 1, opacity: 1 }}
        transition={{ duration: 0.3 }}
        className="modal-content"
      >
        <button className="modal-close" onClick={onClose}>✖</button>

        <h2 className="modal-title">Login</h2>

        <form onSubmit={handleSubmit} className="modal-form">
          <input
            type="email"
            name="email"
            placeholder="Enter your email"
            value={form.email}
            onChange={handleChange}
            className="modal-input"
          />
          <input
            type="password"
            name="password"
            placeholder="Enter your password"
            value={form.password}
            onChange={handleChange}
            className="modal-input"
          />
          <button type="submit" className="modal-btn">Login</button>
        </form>
      </motion.div>
    </div>
  );
}
